module.exports = __webpack_public_path__ + "static/media/Boat2.59fdb0cb.jpg";